import { render, staticRenderFns } from "./PickupNotifications.vue?vue&type=template&id=5d722e0c&"
import script from "./PickupNotifications.vue?vue&type=script&lang=js&"
export * from "./PickupNotifications.vue?vue&type=script&lang=js&"
import style0 from "./PickupNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports